import OrganizacionService from '../services/OrganizacionService'

const state = () => ({
  loading: false,
  list: []
})

const getters = {
  ORGANIZACIONES_LOADING: state => {
    return state.loading
  },
  ORGANIZACIONES: state => {
    return state.list
  }
}

const mutations = {
  SET_ORGANIZACIONES_LOADING: (state, payload) => {
    state.loading = payload
  },
  SET_ORGANIZACIONES: (state, payload) => {
    state.list = payload
  }
}

const actions = {
  LOAD_ORGANIZACIONES: async ({ commit }, filter) => {
    try {
      commit('SET_ORGANIZACIONES_LOADING', true)
      let { data, status } = await OrganizacionService.get(filter)
      if (status === 200) {
        commit('SET_ORGANIZACIONES', data)
      }
    } catch (error) {
      console.error(error)
    } finally {
      commit('SET_ORGANIZACIONES_LOADING', false)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
